import { render, staticRenderFns } from "./SalesMaterialEdit.vue?vue&type=template&id=8317294c&scoped=true&"
import script from "./SalesMaterialEdit.vue?vue&type=script&lang=js&"
export * from "./SalesMaterialEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8317294c",
  null
  
)

export default component.exports